<template>
  <v-dialog
    v-model="showModal"
    content-class="fixed-height-md"
    max-width="600px"
  >
    <modal-card
      v-if="selectedQuestionnaire"
      @close="showModal = false"
      full
      fixed
      :title="modalTitle"
    >
      <div class="info-list ma-0">
        <div class="info-list__item pb-5" v-if="answers.length > 1">
          <v-btn
            v-for="record in answers"
            :color="isSelected(record.key) ? 'appMain' : 'defaultActive'"
            text-color="white"
            :key="record.key"
            class="mr-4"
            @click="selectQuestionnaire(record.key)"
            >{{ record.title }}</v-btn
          >
        </div>

        <div
          class="info-list__item"
          v-for="schema in questionnaireFields"
          :key="schema.field"
        >
          <div class="info-list__item-title" v-html="schema.title"></div>
          <div class="info-list__item-value">
            <template v-if="Array.isArray(selectedAnswers[schema.field])">
              <v-chip
                color="primary"
                text-color="white"
                v-for="(tag, idx) in selectedAnswers[schema.field]"
                :key="idx"
                label
              >
                {{ tag }}
              </v-chip>
            </template>
            <template v-else>
              {{ selectedAnswers[schema.field] }}
            </template>
          </div>
        </div>
      </div>
    </modal-card>
  </v-dialog>
</template>

<script>
import { eventBus } from '@/lib/events';
import { mapGetters, mapState } from 'vuex';
import questionnaires from '../../data/questionnaries';

export default {
  name: 'QuestionnaireAnswersViewer',
  data() {
    return {
      record: null,
      selectedQuestionnaireKey: 'preScreenInterview',
      showModal: false,
    };
  },
  computed: {
    ...mapState('rooms', ['roomInfo']),
    ...mapGetters('rooms', ['getParticipantRecords']),
    answers() {
      return (this.record?.answers || []).slice().sort((a, b) => {
        return (b?.key || '').localeCompare(a?.key || '');
      });
    },

    modalTitle() {
      return `${this.record.name}: ${this.selectedQuestionnaire.title}`;
    },

    selectedQuestionnaire() {
      if (!this.record) return;
      return this.record.answers.find(({ key }) => {
        return key === this.selectedQuestionnaireKey;
      });
    },

    selectedAnswers() {
      return this.selectedQuestionnaire?.answer || {};
    },

    questionnaireForm() {
      if (!this.selectedQuestionnaire) return {};
      return questionnaires[this.selectedQuestionnaireKey];
    },

    questionnaireFields() {
      const fieldsArr = Object.keys(this.questionnaireForm?.fields) || [];
      return fieldsArr.reduce((acc, field) => {
        let schema = this.questionnaireForm?.fields[field];
        if (this.isFieldVisible(schema)) {
          acc.push({
            ...schema,
            field,
          });
        }
        return acc;
      }, []);
    },
  },
  methods: {
    isFieldVisible(fieldSchema) {
      const { office } = fieldSchema;
      if (office) {
        return (this.roomInfo?.on || '').startsWith(office);
      }
      return true;
    },

    showAnswer(record) {
      this.showModal = true;
      this.record = record;
    },

    isSelected(key) {
      return this.selectedQuestionnaireKey === key;
    },

    selectQuestionnaire(key) {
      this.selectedQuestionnaireKey = key;
    },
  },
  mounted() {
    eventBus.on('showParticipantAnswers', (data) => {
      let { participantId, key } = data;
      const record = this.getParticipantRecords(participantId);
      if (!record) return;

      this.showAnswer(record);
      if (!key && this.answers) {
        key = this.answers[0].key;
      }

      this.selectQuestionnaire(key);
    });
  },
};
</script>

<style scoped>
.info-list__item:first-child {
  padding-top: 20px;
}
.info-list__item:last-child {
  padding-bottom: 20px;
}
</style>
